import React from 'react'
import shoppieslogo from '../assets/shoppies-logo.png';

//stateless component
const Titlebar = () => (
  <div>
    <img src={shoppieslogo} alt="shoppieslogo" />
    <h5>movie awards for entrepreneurs</h5>
  </div>
)

export default Titlebar
